import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import Home24Main from './Home24Main.vue'
registerVueComponentAndAngularBindings('home24:main', 'home24Main', Home24Main)

import { loadLocales } from '/vodalys/vvuejs/vue'

// import fr from '**/lang/fr.js'

// console.error('plop', fr)




// // import i18n from './lang/*.js'
// loadLocales('/vodalys2023/home24/main', i18n, 'home24_main')